<template>
  <section :class="$style.container">
    <Wrapper :class="$style.inner" data-aos="fade-up">
      <a
        v-for="(item, itemIndex) in items"
        :key="itemIndex"
        :class="$style.item"
        :href="item.link ? item.link.url : ''"
        target="_blank"
        rel="nofollow"
      >
        <div>
          <span v-if="item.score" :class="$style.score">
            {{ parseScore(item.score) }}/5
          </span>
        </div>
        <div v-if="item.score" :class="$style.stars">
          <Star
            v-for="(ratio, idx) in ratioArray(item.score)"
            :key="idx"
            :ratio="ratio"
            color="blue"
            :size="30"
            bg-color="#ACBEF7"
          />
        </div>
        <PImage
          :image-object="item.image"
          :class="$style.image"
          :quality="50"
        />
      </a>
    </Wrapper>
  </section>
</template>

<script>
import Star from '~/components/Star'

export default {
  name: 'TestimonialsScore',
  components: {
    Star,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      content: this.slice.primary,
      items: this.slice.items,
    }
  },

  methods: {
    parseScore(score) {
      return score.toString().replace('.', ',')
    },
    ratioArray(score) {
      return new Array(5).fill(0).map((c) => {
        if (score > 1) {
          score -= 1
          return 1
        }
        const tmp = score
        score = 0
        return tmp
      })
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 80px 0 0;
}

.inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 768px;

  @include below(medium) {
    grid-template-columns: 1fr 1fr;
    margin: 0 auto;
  }
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 230px;
  margin: 40px 0;

  color: black;

  text-decoration: none;
}

.score {
  font-weight: 200;
  font-size: 65px;
  line-height: 80px;
}

.stars {
  display: flex;
  margin-bottom: 15px;
}
.image {
  height: 24px;
}
</style>
